<template>
  <div class="mktops-bookprice mktops-request-price">
    <div
      style="position: absolute; top: 50%; left: 50%; width: 10%; z-index: 2"
      v-show="loading == true"
    >
      <md-progress-spinner
        :md-stroke="8"
        :md-diameter="65"
        md-mode="indeterminate"
      ></md-progress-spinner>
      <div v-if="loading" class="bg-overlay-unset" style="z-index: 15"></div>
    </div>

    <div class="md-layout">
      <!-- HEAD PAGE -->
      <div class="md-layout-item md-size-100 head-page">
        <div class="md-layout-item md-size-80">MANAGE BOOK PRICE</div>
        <div class="md-layout-item md-size-20 message-bog"></div>
        <!-- <div
          class="md-layout-item md-size-20 message-bog"
          style="cursor: pointer;"
          @click="onClickMessage()"
        >
          กล่องข้อความ
          <md-icon style="margin-right: 10px;">mail_outline</md-icon>
          <span class="custom-chip">{{ formatNumber(messageAlert, 0) }}</span>
        </div> -->
      </div>

      <!-- TAB -->
      <div class="md-layout-item md-size-100">
        <div class="custom-tabs">
          <div
            v-if="isAdd || isDelete"
            class="virtual-tab"
            :class="valueTab == 'REQUEST_PRICE' ? 'tab-active' : ''"
            @click="onClickTab('REQUEST_PRICE')"
          >
            REQUEST PRICE
            <span class="tab-chip -primary">
              {{ formatNumber(countReqPrice, 0) }}
            </span>
          </div>
          <div
            class="virtual-tab"
            :class="valueTab == 'ALL_BOOK_PRICE' ? 'tab-active' : ''"
            @click="onClickTab('ALL_BOOK_PRICE')"
          >
            ALL BOOK PRICE
            <span class="tab-chip -chipgray">
              {{ formatNumber(countGroupBook, 0) }}
            </span>
          </div>
        </div>
      </div>

      <!-- BLOCK ACTION -->
      <div class="md-layout block-action" style="width: 100%;">
        <!-- <div class="selected-search" style="width: 15%;"> -->
        <div
          class="selected-search md-layout-item md-xlarge-size-10 md-large-size-15 md-medium-size-15"
        >
          <md-field class="box">
            <md-select v-model="selectedSearch" @md-selected="onChangeSearch()">
              <!-- :disabled="valueTab == 'REQUEST_PRICE' ? false : true" -->
              <md-option
                class="select-search"
                v-for="(item, index) in selectSearch"
                :key="index"
                :value="index"
                >{{ item }}</md-option
              >
            </md-select>
          </md-field>
        </div>

        <!-- <div class="input-search" style="width: 25%;"> -->
        <div
          class="input-search md-layout-item md-xlarge-size-25 md-large-size-30 md-medium-size-30"
          style="margin-right: 0px; padding-right: 10px;"
        >
          <md-field class="md-search-box">
            <md-icon>search</md-icon>
            <md-input
              type="text"
              placeholder="Search with by code"
              v-model="valueSearch"
              @input="onChangeSearch()"
            ></md-input>
          </md-field>
        </div>

        <!-- <div class="md-layout-item md-xlarge-size-hide md-large-size-hide md-medium-size-hide md-small-size-hide"></div> -->

        <!-- style="padding-left: 5px; margin-top: 3px; width: 20%;" -->
        <div
          class="md-layout-item md-xlarge-size-15 md-large-size-20 md-medium-size-25"
          style="padding-left: 5px; margin-top: 3px;"
          v-show="valueTab == 'REQUEST_PRICE'"
        >
          <!-- class="
          md-layout-item md-large-size-20 md-medium-size-20 md-small-size-20
        " -->
          <multiselect
            v-model="selectedCreateBy"
            id="name"
            label="name"
            track-by="name"
            placeholder="Create By"
            :open-direction="'bottom'"
            :options="optionsCreateBy"
            :searchable="true"
            :max-height="180"
            :show-no-results="false"
            :select-label="''"
            :deselect-label="''"
            :selected-label="''"
            :hide-selected="true"
            @select="setDataCreateBy"
          >
            <template slot="singleLabel" slot-scope="{ option }">
              <div>
                <div
                  class="-label"
                  style="font-family: kanit; padding-top: 3px"
                >
                  {{ option.name }}
                </div>
                <div
                  class="-delete"
                  style="padding-top: 2px; margin-right: 8px"
                  @mousedown.prevent.stop="clearAll('createby')"
                >
                  <i class="material-icons">close</i>
                </div>
              </div>
            </template>
          </multiselect>
        </div>

        <div
          v-if="valueTab == 'ALL_BOOK_PRICE'"
          class="md-layout-item md-xlarge-size-10 md-large-size-10 md-medium-size-10"
          style="width: 10%; text-align: right; padding: 19px 15px 0 0; font-weight: bold;"
        >
          <!-- style="width: 10%; text-align: right; padding: 19px 15px 0 0; font-weight: bold;" -->
          Book Type
        </div>
        <div
          class="md-layout-item md-xlarge-size-15 md-large-size-20 md-medium-size-15"
          style="padding-left: 5px; margin-top: 3px; width: 20%"
          v-if="valueTab == 'ALL_BOOK_PRICE'"
        >
          <!-- style="padding-left: 5px; margin-top: 3px; width: 20%" -->
          <!-- class="md-layout-item md-large-size-20 md-medium-size-20 md-small-size-20" -->
          <multiselect
            v-model="selectedBookType"
            id="code"
            label="title"
            track-by="code"
            placeholder="All"
            :open-direction="'bottom'"
            :options="optionsBookType"
            :custom-label="customLabel"
            :searchable="true"
            :max-height="180"
            :show-no-results="false"
            :select-label="''"
            :deselect-label="''"
            :selected-label="''"
            :hide-selected="true"
            @select="setDataBookType"
          >
            <template slot="singleLabel" slot-scope="{ option }">
              <div>
                <div
                  class="-label"
                  style="font-family: kanit; padding-top: 3px"
                >
                  {{ option.code + " : " + option.title }}
                </div>
                <div
                  class="-delete"
                  style="padding-top: 2px; margin-right: 8px"
                  @mousedown.prevent.stop="clearAll('booktype')"
                >
                  <i class="material-icons">close</i>
                </div>
              </div>
            </template>
          </multiselect>
        </div>

        <div
          class="button-create md-layout-item"
          :class="
            valueTab == 'REQUEST_PRICE'
              ? 'md-xlarge-size-45 md-large-size-30 md-medium-size-10'
              : 'md-xlarge-size-35 md-large-size-20 md-medium-size-25'
          "
        >
          <!-- :style="valueTab == 'REQUEST_PRICE' ? 'width: 35%' : 'width: 25%;'" -->
          <md-button
            v-if="isAdd && valueTab == 'ALL_BOOK_PRICE'"
            class="md-raised md-primary"
            @click="createGroupBook()"
          >
            <md-icon>add</md-icon>
            <div>CREATE BOOK CODE</div>
          </md-button>
        </div>
        <!-- <div style='float: right;padding-left: 5px;margin-top: 3px;'>
            <md-button title='Files List' style="margin-left:0;margin-right:0" @click="filesList()">
                <i class="md-icon material-icons">list_alt</i>
            </md-button>
        </div> -->
        <!-- <div class="md-layout-item md-size-5" style="width: 5%;"> -->
        <div class="md-layout-item md-size-5">
          <i
            class="md-icon material-icons -list_alt"
            style="
              color: #b3b3b3;
              cursor: pointer;
              font-size: 25px !important;
              margin-top: 14px;
              margin-left: 10px;
            "
            title="Files List"
            @click="filesList"
            >list_alt</i
          >
        </div>
      </div>

      <!-- TABLE -->
      <div class="md-layout-item md-size-100 table-book-price">
        <!-- HEAD -->
        <div class="divHeadList">
          <div v-show="valueTab == 'REQUEST_PRICE'" style="width: 8%">
            Doc No.
          </div>
          <div
            :style="valueTab == 'REQUEST_PRICE' ? 'width: 10%;' : 'width: 7%;'"
          >
            Book Code
          </div>
          <div
            :style="
              valueTab == 'REQUEST_PRICE' ? 'width: 28%;' : 'width: 27.5%;'
            "
          >
            Description
          </div>
          <div
            :style="valueTab == 'REQUEST_PRICE' ? 'width: 6%;' : 'width: 12%;'"
            v-show="valueTab == 'ALL_BOOK_PRICE'"
            class="-text-right"
          >
            Sum Cust.
          </div>
          <div
            :style="
              valueTab == 'REQUEST_PRICE'
                ? 'width: 9.5%; padding-right: 30px;'
                : 'width: 12%;'
            "
            class="-text-right"
          >
            Sum Item
          </div>
          <div
            :style="
              valueTab == 'REQUEST_PRICE'
                ? 'width: 17%; padding-left: 35px;'
                : 'width: 21%; padding-left: 70px;'
            "
          >
            Create By
          </div>
          <div
            :style="valueTab == 'REQUEST_PRICE' ? 'width: 16%;' : 'width: 16%;'"
            class="-text-center"
          >
            Create date
          </div>
          <!-- <div
            v-show="valueTab == 'REQUEST_PRICE'"
            style="width: 15%; padding-left: 25px;"
          >
            Holder By
          </div> -->
          <!-- <div v-show="valueTab == 'REQUEST_PRICE'" style="width: 9.5%;">
            Status
          </div> -->
          <div v-show="valueTab == 'REQUEST_PRICE'" style="width: 8%"></div>
          <div style="width: 2.5%"></div>
        </div>

        <!-- BODY -->
        <div class="divBodyList">
          <div
            v-show="tableBookPrice.length === 0"
            :class="'row-bg-gray'"
            style="display: block; text-align: center; font-size: 14px"
          >
            No data in table.
          </div>

          <!-- :style="valueTab == 'REQUEST_PRICE' ? 'cursor: pointer;' : ''" -->
          <div
            :class="'row-bg-gray'"
            v-for="(item, rIndex) in tableBookPrice"
            :key="rIndex"
          >
            <div
              v-show="valueTab == 'REQUEST_PRICE'"
              style="
                width: 8%;
                color: #1a73e8;
                font-weight: bold;
                padding-top: 2px;
                cursor: pointer;
              "
              @click="onSelectRow(item)"
            >
              {{ item.doc_no }}
            </div>
            <div
              :style="
                valueTab == 'REQUEST_PRICE' ? 'width: 10%;' : 'width: 7%;'
              "
            >
              {{ item.code }}
            </div>
            <div
              :style="
                valueTab == 'REQUEST_PRICE' ? 'width: 28%;' : 'width: 27.5%;'
              "
              :title="item.desc"
              class="nowrap-title -font-kanit"
            >
              {{ item.desc }}
            </div>
            <div
              :style="
                valueTab == 'REQUEST_PRICE' ? 'width: 6%;' : 'width: 12%;'
              "
              v-show="valueTab == 'ALL_BOOK_PRICE'"
              class="-text-right"
            >
              {{ item.sum_cust }}
            </div>
            <div
              :style="
                valueTab == 'REQUEST_PRICE'
                  ? 'width: 9.5%; padding-right: 30px;'
                  : 'width: 12%;'
              "
              class="-text-right"
            >
              {{ item.sum_item }}
            </div>
            <div
              :style="
                valueTab == 'REQUEST_PRICE'
                  ? 'width: 17%; padding-left: 35px;'
                  : 'width: 21%; padding-left: 70px;'
              "
              class="-font-kanit"
            >
              {{ item.create_by }}
            </div>
            <div
              :style="
                valueTab == 'REQUEST_PRICE' ? 'width: 16%;' : 'width: 16%;'
              "
              class="-text-center"
            >
              {{ formatDate(item.c_date) }}
            </div>
            <!-- <div
              v-show="valueTab == 'REQUEST_PRICE'"
              style="width: 15%; padding-left: 25px;"
              class="-font-kanit"
            >
              {{ item.holder_by }}
            </div> -->
            <!-- <div v-show="valueTab == 'REQUEST_PRICE'" style="width: 9.5%;">
              {{ displayStatus(item.status) }}
            </div> -->

            <div
              style="width: 8%"
              v-show="valueTab == 'REQUEST_PRICE'"
              class="-text-center"
            >
              <md-button
                class="md-raised md-primary"
                style="
                  width: 65px;
                  min-width: 65px;
                  height: 23px;
                  margin: 0;
                  border-radius: 5px;
                  background-color: #4789da;
                "
                @click="onShare(item)"
              >
                <div style="font-size: 12px">SHARE</div>
              </md-button>
            </div>

            <div style="width: 2.5%" class="-text-center">
              <md-menu
                md-size="big"
                v-if="
                  (isView && valueTab === 'ALL_BOOK_PRICE') ||
                    (isAdd && valueTab === 'ALL_BOOK_PRICE') ||
                    (isAdd && valueTab === 'ALL_BOOK_PRICE') ||
                    (isDelete &&
                      dataToken.code === item.create_code &&
                      valueTab === 'REQUEST_PRICE' &&
                      (item.status === 'Draft' || item.status === 'Return'))
                "
              >
                <md-button class="md-icon-button" md-menu-trigger>
                  <md-icon>more_vert</md-icon>
                </md-button>
                <md-menu-content class="menu-vert-bookprice">
                  <md-menu-item
                    v-if="isView && valueTab === 'ALL_BOOK_PRICE'"
                    class="row-bg-gray"
                    @click="onClickBookPrice(item)"
                  >
                    <span>View Book Price</span>
                  </md-menu-item>
                  <md-menu-item
                    v-show="isAdd && valueTab === 'ALL_BOOK_PRICE'"
                    class="row-bg-gray"
                    @click="onSelectRow(item, 'request')"
                  >
                    <span>Request Price</span>
                  </md-menu-item>
                  <md-menu-item
                    v-if="isAdd && valueTab === 'ALL_BOOK_PRICE'"
                    class="row-bg-gray"
                    @click="createGroupBook(item)"
                  >
                    <span>Edit Customer in book</span>
                  </md-menu-item>
                  <md-menu-item
                    v-show="
                      isDelete &&
                        dataToken.code === item.create_code &&
                        valueTab === 'REQUEST_PRICE' &&
                        (item.status === 'Draft' || item.status === 'Return')
                    "
                    class="row-bg-gray"
                    @click="deleteGroupBook(item)"
                  >
                    <span>Delete group book</span>
                  </md-menu-item>
                </md-menu-content>
              </md-menu>
            </div>
          </div>
        </div>

        <!-- FOOTER -->
        <div class="footer-table">
          number of lines in page ({{ tableBookPrice.length }})
        </div>
      </div>
    </div>

    <dialog-files-list
      :show="showDialogFilesList"
      :data="dataFilesList"
      @cancel="onClickCancelFilesList"
      @confirm="onClickComfirmFilesList"
    ></dialog-files-list>
    <dialog-group-book
      :show="showDialogGroupBook"
      :mode="modeDialogGB"
      :dataCustomer="dataCustomer"
      :optionsBookType="optionsBookType"
      @cancel="onClickCancel()"
      @confirm="onClickConfirm()"
    ></dialog-group-book>
    <!-- :genBookCode="genBookCode" -->
    <!-- :dataCustomer="customerAutoSearch" -->

    <dialog-confirm
      :show="showDialogConfirm"
      :content="contentDialog"
      :confirmText="confirmText"
      :cancelText="cancelText"
      @cancel="onCancel()"
      @confirm="onConfirm()"
    ></dialog-confirm>

    <dialog-share-template
      :show="showShareDialog"
      :searchUser="searchUser"
      :dataShareFile="dataShareFile"
      @cancel="onCancelShare()"
      @confirm="onCancelShare()"
    ></dialog-share-template>
    <!-- :url="urlShare" -->
    <!-- :tableShareUser="tableShareUser" -->
    <!-- @md-closed="shareClose()" -->

    <md-snackbar
      :md-position="position"
      :md-duration="isInfinity ? Infinity : duration"
      :md-active.sync="showSnackbar"
      md-persistent
    >
      <span>{{ contentSnackbar }}</span>
      <md-button class="md-primary" @click="showSnackbar = false">OK</md-button>
    </md-snackbar>
  </div>
</template>

<script>
import GlobalService from "@/services/global_function";
import BookpriceService from "@/services/bookprice";
import DialogFilesList from "./../pricing/bookprice/dialog-files-list";
import DialogGroupBook from "./../pricing/bookprice/dialog-group-book";
import DialogConfirm from "./../shared/dialog-confirm";
import DialogShareTemplate from "./bookprice/dialog-share-template";

export default {
  name: "book-price",

  components: {
    DialogFilesList,
    DialogShareTemplate,
    DialogGroupBook,
    DialogConfirm,
  },

  computed: {
    permit() {
      return this.$jwt.decode(localStorage.getItem("token"));
    },
    isView() {
      return this.permit.acl["overview"].menus["book-price"].view;
    },
    isAdd() {
      return this.permit.acl["overview"].menus["book-price"].add;
    },
    isDelete() {
      return this.permit.acl["overview"].menus["book-price"].delete;
    },
  },

  data() {
    return {
      loadData: false,
      countGroupBook: 0,
      countReqPrice: 0,
      messageAlert: 0,
      valueTab: "REQUEST_PRICE",
      selectedSearch: 0,
      selectSearch: ["Product", "Customer", "Description"],
      valueSearch: "",
      tableBookPrice: [],
      tmpTableBookPrice: [],
      dataFilesList: [],
      showDialogFilesList: false,
      showDialogGroupBook: false,
      showShareDialog: false,
      // urlShare: "",
      tableShareUser: [],
      dataShareFile: [],
      searchUser: [],
      dataCustomer: {},
      modeDialogGB: "",
      loading: false,
      dataToken: {},
      showDialogConfirm: false,
      contentDialog: "",
      confirmText: "OK",
      cancelText: "CANCEL",
      idDeleteRow: "",
      showSnackbar: false,
      position: "center",
      duration: 20000,
      isInfinity: false,
      contentSnackbar: "",
      selectedCreateBy: [],
      optionsCreateBy: [],
      checkDelete: false,
      selectedBookType: [],
      optionsBookType: [],
      booktypeCode: "",
    };
  },

  created() {
    this.dataToken = this.$jwt.decode(localStorage.getItem("token"));
    if (!this.isAdd && !this.isDelete) {
      this.valueTab = "ALL_BOOK_PRICE";
    }
    this.loading = true;
    // this.getUserActivity();
    this.getListDataTable();
    this.getNumberGroupbook();
    this.getBookType();
  },

  methods: {
    getBookType() {
      BookpriceService.getBookType().then((response) => {
        this.optionsBookType = response;
      });
    },
    customLabel({ code, title }) {
      return `${code} : ${title}`;
    },
    setDataBookType(selectedOption) {
      this.booktypeCode = selectedOption.code;
      this.onChangeSearch();
    },
    setDataCreateBy(selectedOption) {
      let datas = this.tmpTableBookPrice.filter((item) => {
        return selectedOption.name === item.create_by;
      });
      this.tableBookPrice = datas;
    },
    clearAll(type) {
      if (type == "createby") {
        this.selectedCreateBy = [];
      } else if (type == "booktype") {
        this.selectedBookType = [];
        this.booktypeCode = "";
      }
      this.loading = true;
      this.getListDataTable();
      this.getNumberGroupbook();
    },
    formatNumber(value, dicimal) {
      return GlobalService.formatNumber(value, dicimal);
    },
    formatDate(date) {
      return GlobalService.formatDate(date, "DD-MM-YYYY HH:mm:ss");
    },
    // getUserActivity() {
    //   // console.log("- 1 -");
    //   BookpriceService.getUserActivity({ emp_code: this.dataToken.code }).then(
    //     (response) => {
    //       localStorage.setItem("user_activity", JSON.stringify(response.data));
    //       localStorage.setItem("show_cost", response.data.show_cost);
    //     }
    //   );
    // },
    displayStatus(status) {
      if (status === "wait_approve_pmd" || status === "Wait approve") {
        return "Wait Approve";
      } else {
        return status;
      }
    },
    getNumberGroupbook() {
      BookpriceService.getNumberGroupbook({
        tab: "all",
        emp_code: this.dataToken.code,
      }).then((response) => {
        this.countGroupBook = response;
      });
      BookpriceService.getNumberGroupbook({
        tab: "request",
        emp_code: this.dataToken.code,
      }).then((response) => {
        this.countReqPrice = response;
      });
    },
    getListDataTable() {
      let typeSearch = "product";
      if (this.selectedSearch === 0) {
        typeSearch = "product";
      } else if (this.selectedSearch === 1) {
        typeSearch = "customer";
      } else if (this.selectedSearch === 2) {
        typeSearch = "description";
      }
      let datas = {
        type: typeSearch,
        keyword: this.valueSearch,
        tab: this.valueTab === "ALL_BOOK_PRICE" ? "" : "request",
        emp_code: this.dataToken.code,
        booktype: this.booktypeCode,
      };

      this.tableBookPrice = [];
      BookpriceService.getListDataTable(datas)
        .then((response) => {
          if (this.valueTab === "ALL_BOOK_PRICE") {
            response.sort((a, b) => (a.code > b.code ? 1 : -1));
          } else {
            response.sort((a, b) => (a.doc_no > b.doc_no ? 1 : -1));
          }
          this.tableBookPrice = response;
          this.tmpTableBookPrice = response;

          // this.optionsCreateBy = [];
          if (this.optionsCreateBy.length === 0) {
            response.forEach((element) => {
              let key = this.optionsCreateBy.findIndex((item) => {
                return element.create_by === item.name;
              });
              if (key === -1) {
                this.optionsCreateBy.push({ name: element.create_by });
              }
            });
          }

          if (this.selectedCreateBy.length !== 0) {
            let datas = response.filter((item) => {
              return this.selectedCreateBy.name === item.create_by;
            });
            this.tableBookPrice = datas;
          }

          this.loading = false;
        })
        .catch((error) => {
          if (error.response) {
            if (error.response.status == "404") {
              this.tableRequestPrice = [];
              this.contentSnackbar = error.response.data.message;
              this.showSnackbar = true;
              this.loading = false;
              return;
            } else {
              this.tableRequestPrice = [];
              this.contentSnackbar = error.response.data.errors.title;
              this.showSnackbar = true;
              this.loading = false;
              return;
            }
          }
        });
    },
    onChangeSearch() {
      this.loading = true;
      this.getListDataTable();
    },
    onClickTab(value_tab) {
      this.loadData = true;
      this.valueTab = value_tab;
      if (this.valueTab === "ALL_BOOK_PRICE") {
        this.selectedSearch = 1;
      } else {
        this.selectedSearch = 0;
      }
      this.valueSearch = "";
      // this.getListDataTable();
    },
    filesList(item) {
      this.loading = true;
      let emp_code = this.dataToken.code;
      BookpriceService.checkDataDelete(emp_code).then((response) => {
        this.loading = false;
        if (!response.status) {
          this.contentSnackbar = "No user file found.";
          this.showSnackbar = true;
          return false;
        } else {
          this.showDialogFilesList = true;
          this.dataFilesList = response.file.sort(function(a, b) {
            var keyA = new Date(a.modifiedTime),
              keyB = new Date(b.modifiedTime);
            if (keyA < keyB) return 1;
            if (keyA > keyB) return -1;
            return 0;
          });
        }
      });
    },
    createGroupBook(item) {
      this.dataCustomer = {};
      if (item !== undefined) {
        this.modeDialogGB = "EDIT";
        BookpriceService.getGroupbookDetail({
          id: item._id,
          tab: this.valueTab === "ALL_BOOK_PRICE" ? "" : "request",
        }).then((response) => {
          if (response.length > 0) {
            this.dataCustomer = response[0];
          }
          this.showDialogGroupBook = true;
        });
      } else {
        this.modeDialogGB = "ADD";
        this.showDialogGroupBook = true;
      }
    },
    deleteGroupBook(item) {
      this.idDeleteRow = item._id;
      this.contentDialog =
        "Are you sure you want to delete (Doc No. " + item.doc_no + ") ?";
      this.confirmText = "OK";
      this.cancelText = "CANCEL";
      this.showDialogConfirm = true;
    },
    onClickBookPrice(item) {
      let datas = item;
      datas.tab = "bookprice";
      localStorage.setItem("click_book_price", JSON.stringify(datas));
      localStorage.removeItem("row_request_price");
      this.$router.push("/overview/pricing-list");
    },
    onClickCancel() {
      this.showDialogGroupBook = false;
    },
    onClickConfirm() {
      this.loading = true;
      this.getListDataTable();
      this.getNumberGroupbook();
      this.showDialogGroupBook = false;
    },
    onClickCancelFilesList() {
      this.showDialogFilesList = false;
    },
    onClickComfirmFilesList(files) {
      this.loading = true;
      BookpriceService.deleteTemplateFile(files, this.dataToken.code)
        .then((response) => {
          this.loading = false;
          if (response.status) {
            this.contentSnackbar = "Delete files successfully.";
            this.showSnackbar = true;
          }
        })
        .catch((error) => {
          if (error.response) {
            this.contentSnackbar = error.response.data.message;
            this.showSnackbar = true;
            this.loading = false;
            return;
          }
        });
      this.showDialogFilesList = false;
    },
    onSelectRow(item, type) {
      if (this.isAdd) {
        let datas = item;
        datas.tab = this.valueTab;
        localStorage.setItem("row_request_price", JSON.stringify(datas));
        if (this.valueTab === "REQUEST_PRICE" || type === "request") {
          this.$router.push("/overview/request-price");
        }
      }
    },
    onShare(item) {
      this.loading = true;
      BookpriceService.getShareDetail({
        id: item._id,
        emp_code: this.dataToken.code,
      }).then((response) => {
        // this.urlShare = response.data.url;
        //        if (response.data.approver) {
        //          response.data.approver["approve"] = true;
        //        }
        //        this.tableShareUser = [response.data.approver];

        if (response.data.length > 0) {
          this.dataShareFile = response.data;
          // if (response.data.user.length > 0) {
          // let labelName = "";
          // let labelLastName = "";
          // let rsDatas = [];
          // let rs = {};
          // response.data.user.forEach(element => {
          //   let elLabel = element.label.split(" ");
          //   labelName =
          //     elLabel[0].substring(0, 1).toUpperCase() +
          //     elLabel[0].substring(1).toLowerCase();
          //   labelLastName =
          //     elLabel[1].substring(0, 1).toUpperCase() +
          //     elLabel[1].substring(1).toLowerCase();
          //   rs = element;
          //   rs["label"] = labelName + " " + labelLastName;
          //   rsDatas.push(rs);
          // });
          // console.log("rsDatas ==>", rsDatas);
          // this.tableShareUser = rsDatas;
        }
        // this.tableShareUser = response.data.user;
        this.loading = false;
        this.showShareDialog = true;
      });

      BookpriceService.getShareUser().then((response) => {
        let labelName = "";
        let labelLastName = "";
        let rsDatas = [];
        let rs = {};
        response.data.forEach((element) => {
          let elLabel = element.label.split(" ");
          labelName =
            elLabel[0].substring(0, 1).toUpperCase() +
            elLabel[0].substring(1).toLowerCase();
          labelLastName =
            elLabel[1].substring(0, 1).toUpperCase() +
            elLabel[1].substring(1).toLowerCase();
          rs = element;
          rs["label"] = labelName + " " + labelLastName;
          rsDatas.push(rs);
        });

        // this.searchUser = response.data;
        this.searchUser = rsDatas;
      });
    },
    shareClose() {
      //console.log('ss close');
    },
    onClickMessage() {
      this.$router.push("/overview/message");
    },
    onCancel() {
      this.idDeleteRow = "";
      this.showDialogConfirm = false;
    },
    onCancelShare() {
      this.showShareDialog = false;
    },
    onConfirm() {
      BookpriceService.deleteRowBookprice({
        id: this.idDeleteRow,
        user: this.dataToken.code,
      }).then((response) => {
        this.getListDataTable();
        this.getNumberGroupbook();
        this.showDialogConfirm = false;
      });
    },
  },
};
</script>

<style lang="scss">
.mktops-bookprice,
.mktops-request-price,
.book-price-message {
  background-color: #fff;
  font-family: lato;
  height: 100vh;

  .-list_alt:hover {
    color: #3f51b5 !important;
  }

  .head-page {
    font-size: 18px;
    font-weight: bold;
    color: #797979;
    padding: 18px 18px 0px;
    margin-bottom: 10px;
    display: flex;

    .message-bog {
      font-family: kanit;
      font-size: 14px;
      font-weight: normal;
      color: #414141;
      text-align: right;
    }
  }

  .custom-tabs {
    display: flex;
    line-height: 40px;
    box-shadow: 0 0px 0px 0px rgba(0, 0, 0, 0), 0 0px 0px 0 rgba(0, 0, 0, 0),
      0 2px 2px 0 rgba(0, 0, 0, 0.1);

    .virtual-tab {
      padding: 0px 15px;
      width: 18%;
      text-align: center;
      font-weight: 700;
      color: #727272;
      cursor: pointer;

      &.tab-active {
        border-bottom: 3px solid #3f51b5;
      }

      .tab-chip {
        padding-left: 7px;
        padding-right: 7px;
        border-radius: 35px;
        color: white;
        font-size: 12px;
        padding-top: 3px;
        padding-bottom: 3px;
        margin-left: 5px;

        &.-chipgray {
          background-color: #727272;
        }

        &.-primary {
          background-color: #3f51b5;
        }

        &.-warning {
          background-color: #f44336;
        }
      }
    }
  }

  .block-action {
    padding: 12px 18px 8px 18px;
    display: flex;

    .selected-search {
      width: 12%;
      height: 38px;

      .md-field.box > .md-input.md-select-value,
      .md-field.box > .md-menu.md-select {
        font-size: 14px;
        width: 100%;
        height: 36px;
        margin: 10px 9.28px 0 4px;
      }

      .md-field.md-field.box {
        margin-top: unset;
        margin-bottom: unset;
        padding: unset;
      }

      .md-field:after,
      .md-field:before {
        left: unset;
      }

      .md-field.box .md-input.md-input.md-select-value,
      .md-field.box label {
        font-size: 14px;
        padding-left: 12px;
        padding-top: 3px;
        color: #727272;
      }

      .md-field.box .md-select {
        background-color: #efefef;
        border-radius: 3px;
      }
    }

    .input-search {
      width: 30%;
      margin-right: 10px;

      .md-search-box {
        margin: 10px 0px 10px 0px;
        padding-top: unset;
        width: 100%;
        border-radius: 3px;
        min-height: 36px;
        box-shadow: 0 0 3px rgba(0, 0, 0, 0.16), 0 0 0 rgba(0, 0, 0, 0),
          0 1px 1px -2px rgba(0, 0, 0, 0);

        .md-icon {
          margin-left: 10px;
          margin-top: 7px;
          color: rgba(0, 0, 0, 0.54);
        }

        .md-input {
          height: 36px;
          margin-left: 7px;
          font-family: kanit;
          font-weight: 300;
        }

        &.md-field > .md-icon:after,
        &.md-field:after,
        &.md-field:before {
          content: none;
        }
      }
    }

    .button-create {
      width: 58%;
      text-align: right;

      .md-button {
        margin-top: 9px;
        height: 32px;
        border-radius: 3px;
        font-size: 12px;
        font-weight: 700;

        .md-button-content {
          display: flex;

          .md-icon {
            font-size: 16px !important;
          }

          div {
            padding: 6px 6px 0px 5px;
          }
        }
      }
    }
  }

  .table-book-price {
    .divBodyList {
      height: calc(100vmin - 265px);
    }
  }

  .custom-chip {
    border-radius: 35px;
    color: white;
    font-size: 12px;
    min-width: 20px;
    min-height: 20px;
    position: absolute;
    // top: 3.4%;
    bottom: calc(100vmin - 52px);
    right: 1.4%;
    padding: 0px 5px;
    background-color: #f44336;
  }
}

.table-book-price,
.table-customer,
.table-request-price,
.table-message,
.table-change-price,
.table-filter-product,
.table-import-file,
.table-share-file {
  padding: 0px 12px 15px 18px;

  .divHeadList {
    width: 99.6%;
    display: -webkit-inline-box;
    font-size: 13px;
    font-weight: bold;
    margin-top: 15px;
    margin-bottom: 13px;

    div {
      // border: 1px solid pink;
      padding-left: 5px;
      padding-right: 5px;

      &.-text-right {
        text-align: right;
      }

      &.-text-center {
        text-align: center;
      }

      &.-font-kanit {
        font-size: 14px;
        font-family: kanit;
        font-weight: bold;
      }
    }
  }

  .divBodyList {
    width: 100%;
    display: block;
    overflow-y: scroll;

    .row-bg-gray:hover {
      border-radius: 4px;
      background: rgba(236, 236, 235, 1);
    }

    > div {
      width: 100%;
      height: 35px;
      display: -webkit-inline-box;
      padding-top: 5px;
      padding-bottom: 5px;

      div {
        // border: 1px solid pink;
        padding-left: 5px;
        padding-right: 5px;
        font-size: 13px;
        font-weight: 400;

        &.-text-right {
          text-align: right;
        }

        &.-text-center {
          text-align: center;
        }

        &.nowrap-title {
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }

        &.-font-kanit {
          font-size: 14px;
          font-family: kanit;
          font-weight: 300;
        }
      }

      .md-icon {
        font-size: 22px !important;
        cursor: pointer;
      }
    }

    .md-icon-button {
      width: 25px !important;
      min-width: 25px !important;
      height: unset !important;
      min-height: unset !important;
    }

    &::-webkit-scrollbar {
      height: 7px;
      width: 5px;
    }
  }

  .footer-table {
    // border: 1px solid pink;
    display: block;
    text-align: center;
    margin-top: 10px;
    width: 99.6%;
    font-size: 14px;
    font-style: italic;
  }
}

.md-menu-content-big.menu-vert-bookprice {
  .row-bg-gray:hover {
    border-radius: 4px;
    background: rgba(236, 236, 235, 1);
    cursor: pointer;
  }
}

.bookprice-dialog-group-book,
.bookprice-dialog-filter-product,
.bookprice-dialog-compare-customer,
.mktops-request-price {
  .custom-input-search {
    width: 100%;

    .md-search-box {
      margin: 10px 0px 10px 0px;
      padding-top: unset;
      width: 100%;
      border-radius: 3px;
      min-height: 36px;
      box-shadow: 0 0 3px rgba(0, 0, 0, 0.16), 0 0 0 rgba(0, 0, 0, 0),
        0 1px 1px -2px rgba(0, 0, 0, 0);

      .md-icon {
        margin-left: 10px;
        margin-top: 7px;
        color: rgba(0, 0, 0, 0.54);
      }

      .md-input {
        height: 36px;
        margin-left: 7px;
        font-family: kanit;
        font-weight: 300;
      }

      &.md-field > .md-icon:after,
      &.md-field:after,
      &.md-field:before {
        content: none;
      }
    }
  }

  .multiselect {
    font-weight: 300;

    .z-index-top {
      z-index: 10;
    }

    margin: 5px 0px;

    .multiselect__single,
    .multiselect__input {
      font-size: 14px;
      font-weight: 400;

      div {
        display: flex;
        width: 100%;

        .-delete {
          width: 5%;
          margin: 0px 5px;

          .material-icons {
            font-size: 18px;
            margin-top: 1px;
            cursor: pointer;
            color: gray;
          }
        }
      }
    }

    .multiselect__tags {
      padding: 8px 30px 0 8px;

      input {
        font-family: lato;
        font-weight: 300;
        font-family: kanit;
      }

      .multiselect__placeholder {
        margin: 0px;
        padding-left: 5px;
      }

      ::placeholder {
        color: #bdbdbd;
        opacity: 1;
      }
    }

    .multiselect__content-wrapper {
      font-size: 14px;
      z-index: 10;
      font-family: kanit;
    }

    .multiselect__option {
      min-height: 34px;
      padding: 12px 12px 0px 12px;
    }

    ::-webkit-scrollbar {
      width: 8px;
      height: 8px;
    }
  }

  .treeview-box {
    width: 100%;
    margin-top: 9px;
    margin-bottom: 5px;

    .vue-treeselect__multi-value {
      margin: 0;
    }

    .vue-treeselect__multi-value-item-container {
      display: none;
    }

    .vue-treeselect__limit-tip-text {
      display: none;
    }

    .vue-treeselect__input-container {
      padding-top: 1px;
      padding-left: 5px;
    }

    .vue-treeselect__label-container {
      label {
        padding: 5px 5px 5px 10px;

        &.nowrap-title {
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          display: block;
        }

        &.-font-kanit {
          font-size: 14px;
          font-family: kanit;
          font-weight: 300;
        }
      }
    }

    .vue-treeselect__menu {
      &::-webkit-scrollbar {
        height: 7px;
        width: 5px;
      }
    }
  }
}
</style>
